import { render } from "./ViewDataJadwalAsessment.vue?vue&type=template&id=5382aedc"
import script from "./ViewDataJadwalAsessment.vue?vue&type=script&lang=js"
export * from "./ViewDataJadwalAsessment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__